import { observer } from 'mobx-react-lite';
import queryString from 'query-string';
import React, { useContext, useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { history } from '../..';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { LoginValues } from '../../app/models/login';
import { RootStoreContext } from '../../app/stores/rootStore';

const WeverseAuthV3: React.FC<
  RouteComponentProps<{
    session_id: string;
  }>
> = ({ location, match }) => {
  const rootStore = useContext(RootStoreContext);
  const { setSession, getSession } = rootStore.sessionStore;
  const { getWeverseAuthV3, loginWeverseAuthV3 } = rootStore.memberStore;

  const { session_id } = match.params;
  const { client_id, auth_params, callback_url, access_token } = queryString.parse(location.search);

  const formRef = useRef<any | null>(null);
  const inputClientIdRef = useRef<any | null>(null);
  const inputAuthTypeRef = useRef<any | null>(null);
  const inputRedirectMethodRef = useRef<any | null>(null);
  const inputRedirectUriRef = useRef<any | null>(null);

  useEffect(() => {
    if (access_token) {
      // Weverseからのコールバック呼び出し
      (async () => {
        try {
          // セッション取得
          const session = await getSession(session_id);
          // 認証先のパラメータを設定
          const values = new LoginValues();
          values.session_id = session_id;
          values.client_id = session.client_id;
          values.auth_params = session.auth_params;
          values.id = access_token as string;
          // 認証
          await loginWeverseAuthV3(values);
        } catch (error) {
          history.push('/error');
        }
      })();
    } else {
      // 初回呼び出し
      (async () => {
        try {
          // セッション保持
          const session = await setSession({
            session_id: '',
            client_id: client_id as string,
            auth_params: auth_params as string,
            callback_url: callback_url as string,
          });
          // Weverse認証パラメータ作成API呼び出し
          const weverse = await getWeverseAuthV3(session.session_id, session.client_id, session.auth_params);
          // Weverse認証にRedirect!!
          inputClientIdRef.current.name = 'client_id';
          inputClientIdRef.current.value = weverse.client_id;
          inputAuthTypeRef.current.name = 'authType';
          inputAuthTypeRef.current.value = 'post';
          inputRedirectMethodRef.current.name = 'redirect_method';
          inputRedirectMethodRef.current.value = 'POST';
          inputRedirectUriRef.current.name = 'redirect_uri';
          inputRedirectUriRef.current.value = weverse.redirect_uri;
          formRef.current.action = weverse.target_url;
          formRef.current.method = 'GET';
          formRef.current.submit();
        } catch (error) {
          history.push('/error');
        }
      })();
    }
  }, [
    auth_params,
    callback_url,
    client_id,
    access_token,
    session_id,
    getSession,
    getWeverseAuthV3,
    loginWeverseAuthV3,
    setSession,
    location,
    match,
  ]);

  return (
    <form ref={formRef}>
      <input type="hidden" ref={inputClientIdRef} />
      <input type="hidden" ref={inputAuthTypeRef} />
      <input type="hidden" ref={inputRedirectMethodRef} />
      <input type="hidden" ref={inputRedirectUriRef} />
      <input type="hidden" ref={inputRedirectUriRef} />
      <LoadingComponent content="Redirecting..." />
    </form>
  );
};

export default observer(WeverseAuthV3);
